import { useDebugValue } from "react";
import { useTheme } from "@material-ui/core/styles";
import { getThemeProps } from "@material-ui/styles";
import "../dployTheme";
export function useThemeProps(props, name) {
    const theme = useTheme();
    const themeProps = getThemeProps({ theme, name, props: { ...props } });
    useDebugValue(themeProps);
    return themeProps;
}
//# sourceMappingURL=useThemeProps.js.map